import { Program } from '../../../api/newsfeed.types'
import { ProgramsItemAction } from './programs.item.types'

export const programsItemRequestAction = (params: { program_id: number }): ProgramsItemAction => ({ type: 'PROGRAMS_ITEM_REQUEST', params })
export const programsItemSuccessAction = (program: Program): ProgramsItemAction => ({ type: 'PROGRAMS_ITEM_SUCCESS', params: program })
export const programsItemFailureAction = (error?: any): ProgramsItemAction => ({ type: 'PROGRAMS_ITEM_FAILURE', params: error })